//reducer to handle the brands
import {
  FETCH_BRANDS_REQUEST,
  FETCH_BRANDS_SUCCESS,
  FETCH_BRANDS_FAILURE,
} from "../actions/BrandActions";

const initialState = {
  brands: [],
  loading: false,
  error: null,
};

const brandsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BRANDS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_BRANDS_SUCCESS:
      return { ...state, brands: action.payload, loading: false, error: null };
    case FETCH_BRANDS_FAILURE:
      return { ...state, brands: [], loading: false, error: action.payload };
    default:
      return state;
  }
};

export default brandsReducer;
